// 严禁ai修改这个文件
import { isProxy, Log, objectCountUtils, proxyUtils, storeUtils, toParentWatchProxy, toProxy, watchUpdates } from '@fanfanlo';
import _ from 'lodash';
import { ulid } from 'ulid';
import store from 'store2';
import { createDefaultProject } from '../entities/IProject';
import { createDefaultTriggerActionGroup } from '../entities/ITriggerActionGroup';
import { IProject } from '../entities/IProject';
import { createDefaultProjectSettings, IProjectSettings } from '../types/IProjectSettings';
import { syncProject } from '../utils/projectMerge';

export const s = storeUtils.namespace('project-v2');
const listName = 'list';
const draftName = 'draft';
const projectSettingsMapName = "projectSettings"

const fileLog = new Log(false, 'project-v2-interface-storage');
// fileLog.pause = true;
// fileLog.childrenPaused = true;

function loadProjectList(): IProject[] {
  const fnLog = fileLog.sub(false, 'loadProjectList_fn');
  fnLog.pause = true;
  let list = s.read(listName) as IProject[];
  fnLog.log('list=', list);
  if (!_.isArray(list) || !list) list = [];
  const res = prepareProjectList(list);
  return res;
}

function loadDraft(): IProject[] {
  const fnLog = fileLog.sub(false, 'loadDraft_fn');
  fnLog.pause = true;
  let list = s.read(draftName) as IProject[];
  fnLog.log('list=', list);
  if (!_.isArray(list) || !list) list = [];
  const res = prepareProjectList(list);
  return res;
}

function loadProjectSettingsMap():Record<string, IProjectSettings>{
  const fnLog = fileLog.sub(false, 'loadProjectSettingsMap_fn');
  // fnLog.pause = true;
  let map:Record<string, IProjectSettings> = s.read(projectSettingsMapName) as Record<string, IProjectSettings>
  fnLog.log('map=', map)
  fnLog.log('map json =', JSON.stringify(map), 'ismap bool=', _.isMap(map))
  if(!map || !_.isObject(map)) map = {}
  return toProxy(map);
}

function prepareProjectList(list: IProject[]) {
  const fnLog = fileLog.sub(false, 'prepareProjectList_fn');
  fnLog.pause = true;
  return list.map(p => {
    fnLog.log(`[prepareProjectList] 处理项目, ulid=${p.ulid}`);

    // 确保 children 数组存在
    if (!p.children) {
      p.children = [];
      fnLog.log(`[prepareProjectList] 初始化 children 数组`);
    }

    // 确保 children[0] 存在
    if (!p.children[0]) {
      
        // 创建默认值
        const triggerActionGroup = createDefaultTriggerActionGroup();
        p.children[0] = triggerActionGroup;
    }

    const merged = _.merge(createDefaultProject(), p);
    if (!merged.ulid) {
      merged.ulid = ulid();
      fnLog.log(`[数据迁移] 为项目生成 ulid: ${merged.ulid}`);
    }
    return merged;
  });
}

const list: IProject[] = toParentWatchProxy(loadProjectList());
const draft: IProject[] = toParentWatchProxy(loadDraft());

// const projectSettingsMap:Record<string, IProjectSettings> = toParentWatchProxy(loadProjectSettingsMap());
const _projectSettingsMap = loadProjectSettingsMap();
console.log('_projectSettingsMap file init', _projectSettingsMap)
const projectSettingsMap:Record<string, IProjectSettings> = toProxy(_projectSettingsMap);
toParentWatchProxy(projectSettingsMap)
console.log('projectSettingsMap file init', projectSettingsMap,'ssssssss', JSON.stringify(projectSettingsMap))
function printList() {
  const fnLog = fileLog.sub(false, 'printList_fn');
  fnLog.pause = true;
  fnLog.log('storage initialize list=', objectCountUtils.getObjectCount(list), list);
  list.forEach((p, index) => {
    fnLog.log(
      'storage initialize list item=',
      objectCountUtils.getObjectCount(p),
      'index=',
      index,
      'p=',
      p,
      'isproxy=',
      isProxy(p),
    );
  });
}

function printDraft() {
  const fnLog = fileLog.sub(false, 'printDraft_fn');
  fnLog.pause = true;
  fnLog.log('storage initialize draft=', objectCountUtils.getObjectCount(draft), draft);
  draft.forEach((p, index) => {
    fnLog.log(
      'storage initialize draft item=',
      objectCountUtils.getObjectCount(p),
      'index=',
      index,
      'p=',
      p,
      'isproxy=',
      isProxy(p),
    );
  });
}

function init() {
  const fnLog = fileLog.sub(false, 'storage_init_fn');
  fnLog.pause = true;
  watchUpdates(list, () => {
    s.write(listName, list, true);
    fnLog.log('list changed', list);
    printList();
  });
  watchUpdates(draft, () => {
    proxyUtils.runPauseProxyFn(() => {
      s.write(draftName, draft, true);
      fnLog.log('draft changed', draft);
    });
    printDraft();
  });
  // 重新启用 projectSettingsMap 的 watchUpdates，确保数据被持久化
  console.log('projectSettingsMap init fn data', projectSettingsMap, JSON.stringify(projectSettingsMap))
  watchUpdates(projectSettingsMap, function(){
    console.log('projectSettingsMap updates', projectSettingsMap)
    console.log('projectSettingsMap updates2', ...arguments)
    s.write(projectSettingsMapName, projectSettingsMap, true)
  })
  
  fnLog.log('project-v2 store init', list);
  fnLog.log('project-v2 store init', draft);
}

function saveProject(project: IProject) {
  const fnLog = fileLog.sub(false, 'saveProject_fn');
  // fnLog.pause = true;
  const copy = _.cloneDeep(project);
  let index = list.findIndex(p => p.ulid === copy.ulid);

  fnLog.log('[saveProject] 开始保存 project, ulid=', copy.ulid);
  fnLog.log('[saveProject] 查找结果 index=', index);

  if (index === -1) {
    // 新增 project
    fnLog.log('[saveProject] 新增 project, ulid=', copy.ulid);
    index = list.length;
  } else {
    // 更新现有 project
    const existingProject = list[index];
    fnLog.log('[saveProject] 更新现有 project, ulid=', copy.ulid);
    fnLog.log('[saveProject] 现有 project uuid=', existingProject.uuid);
    fnLog.log('[saveProject] 新 project uuid=', copy.uuid);

    // 只要后端返回了 uuid，就执行合并
    if (copy.uuid) {
      fnLog.log('[saveProject] 检测到后端数据（有 uuid），执行合并');
      fnLog.log('[saveProject] 合并前 existingProject:', JSON.stringify({
        ulid: existingProject.ulid,
        uuid: existingProject.uuid,
        title: existingProject.title,
        childrenLength: existingProject.children?.length
      }));
      fnLog.log('[saveProject] 合并前 copy:', JSON.stringify({
        ulid: copy.ulid,
        uuid: copy.uuid,
        title: copy.title,
        childrenLength: copy.children?.length
      }));

      syncProject(existingProject, copy);

      fnLog.log('[saveProject] 合并后 existingProject:', JSON.stringify({
        ulid: existingProject.ulid,
        uuid: existingProject.uuid,
        title: existingProject.title,
        childrenLength: existingProject.children?.length
      }));
      fnLog.log('[saveProject] 合并完成');
      return;
    }
  }

  list[index] = copy;
  fnLog.log('[saveProject] 直接替换完成, list.length=', list.length);
}

function findSavedProject(ulid: string) {
  return list.find(p => p.ulid === ulid);
}

function findProject(ulid: string) {
  return list.find(p => p.ulid === ulid) || draft.find(p => p.ulid === ulid);
}

function findDraftOrSavedProject(ulid: string) {
  return draft.find(p => p.ulid === ulid) || list.find(p => p.ulid === ulid);
}

/**
 * 通过uuid查找项目（用于判断是否已拥有某个项目）
 * 查找逻辑：检查 project.uuid === uuid 或 project.originUuid === uuid
 * @param uuid 项目的uuid或originUuid
 * @returns 找到的项目，或undefined
 */
function findProjectByUuid(uuid: string): IProject | undefined {
  const fnLog = fileLog.sub(false, 'findProjectByUuid_fn');
  fnLog.log('[findProjectByUuid] 开始查找, uuid=', uuid);
  
  // 先在list中查找
  let found = list.find(p => p.uuid === uuid || p.originUuid === uuid);
  if (found) {
    fnLog.log('[findProjectByUuid] 在list中找到, ulid=', found.ulid);
    return found;
  }
  
  // 再在draft中查找
  found = draft.find(p => p.uuid === uuid || p.originUuid === uuid);
  if (found) {
    fnLog.log('[findProjectByUuid] 在draft中找到, ulid=', found.ulid);
    return found;
  }
  
  fnLog.log('[findProjectByUuid] 未找到');
  return undefined;
}

function removeProject(ulid: string) {
  const fnLog = fileLog.sub(false, 'removeProject_fn');
  fnLog.pause = true;
  let index = list.findIndex(p => p.ulid === ulid);
  if (index !== -1) {
    list.splice(index, 1);
    removeProjectSettings(ulid)
    s.write(listName, list, true);
    fnLog.log('project removed', ulid, list);
  }
  removeDraft(ulid);
}

function addDraft(project: IProject): IProject {
  const fnLog = fileLog.sub(false, 'addDraft_fn');
  fnLog.pause = true;
  const p = proxyUtils.runPauseProxyFn(() => {
    return _.cloneDeep(project);
  });
  let index = draft.findIndex(p => p.ulid === project.ulid);
  if (index === -1) index = draft.length;
  draft[index] = p;
  addProjectSettings(project.ulid)
  fnLog.log('draft added', project, draft);
  return draft[index];
}

function getDraft(ulid: string) {
  return draft.find(p => p.ulid === ulid);
}

function removeDraft(ulid: string) {
  const fnLog = fileLog.sub(false, 'deleteDraft_fn');
  fnLog.pause = true;
  let index = draft.findIndex(p => p.ulid === ulid);
  if (index !== -1) {
    draft.splice(index, 1);
    s.write(draftName, draft, true);
    removeProjectSettings(ulid)
    fnLog.log('draft deleted', ulid, draft);
  }
}

function getListCopy() {
  return [...list];
}

function getDraftCopy() {
  return [...draft];
}

function getProjectSettings(ulid:string):IProjectSettings | undefined{
  const fnLog = fileLog.sub(false, "getProjectSettings_fn");
  // fnLog.pause = true;
  let settings = projectSettingsMap[ulid];
  fnLog.log('settings=', ulid, settings)
  if(!settings){
    fnLog.log('!settings', projectSettingsMap, JSON.stringify(projectSettingsMap))
    // 兼容一下之前的代码，没有创建setting的话就补充上一个。
    if(getDraft(ulid)){
      addProjectSettings(ulid)
    }
  }
  return settings
}
function addProjectSettings(ulid:string):IProjectSettings{
  const fnLog = fileLog.sub(false, 'addProjectSettings_fn')
  // fnLog.pause = true;
  const old = projectSettingsMap[ulid];
  fnLog.log('old key=', ulid, 'value = ', JSON.stringify(old), old, `${!old ? 'projectSettingMap= ' + JSON.stringify(projectSettingsMap) : ''}`)
  if(old)return old;
  const newSettings = createDefaultProjectSettings();

  // 直接更新 projectSettingsMap 代理对象
  projectSettingsMap[ulid] = newSettings;
  return newSettings
}
function removeProjectSettings(ulid:string):boolean{
  const fnLog = fileLog.sub(false, 'removeProjectSettings_fn');
  fnLog.pause = true;

  if (!(ulid in projectSettingsMap)) {
    fnLog.log('[removeProjectSettings] ulid 不存在于 projectSettingsMap，无需删除:', ulid);
    return true;
  }

  fnLog.log('[removeProjectSettings] 开始删除 projectSettings, ulid:', ulid);
  const result = delete projectSettingsMap[ulid];
  fnLog.log('[removeProjectSettings] 删除结果:', result);

  return result;
}

// 危险操作，仅限于用户退出登陆时使用.
function cleanStorage(){
  list.length = 0;
  draft.length = 0;
}
export const projectStore = {
  list,
  draft,
  init,
  saveProject,
  findSavedProject,
  findProject,
  findDraftOrSavedProject,
  findProjectByUuid,
  removeProject,
  addDraft,
  getDraft,
  deleteDraft: removeDraft,
  getListCopy,
  getDraftCopy,
  getProjectSettings,
  cleanStorage
};

if (typeof window !== 'undefined') {
  (window as any).getProjectStore = function () {
    fileLog.log('[DEBUG] getProjectStore() called');
    return projectStore;
  };
  init();
  fileLog.log('[DEBUG] projectStore initialized');
}
